import camelCase from 'lodash/camelCase';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { softwareSummaryEmbedRoute } from '@atlassian/jira-router-routes-software-summary-embed-routes/src/softwareSummaryEmbedRoute.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { summarySoftwareEmbedEntrypoint } from '@atlassian/jira-spa-apps-summary/software-embed/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { SummaryEmbedPage, LazySummaryEmbedView } from './ui/index.tsx';

const summarySoftwareEmbedPageEntrypoint = createChromelessEntryPoint({
	main: summarySoftwareEmbedEntrypoint,
});

export const softwareSummaryEmbedRouteEntry = createEntry(softwareSummaryEmbedRoute, () => ({
	group: 'software',
	ufoName: 'next-gen-summary-embed',
	component: componentWithCondition(
		() => expVal('jsw-summary-page-embed-smart-link-experiment', 'isEnabled', false),
		SummaryEmbedPage,
		ErrorPagesNotFound,
	),
	layout: chromelessLayout,
	resources: [
		...getNavigationResources(),
		incidentExperimentTraitResource,
		projectContextResource,
		forgeProjectModuleResource,
		// end of resources expanded from getNavigationSidebarProjectResource
	],
	forPaint: [LazySummaryEmbedView],
	meta: {
		reporting: {
			id: 'software-summary-embed',
			packageName: camelCase('software-summary-embed'),
			teamName: 'Helios - Reports',
		},
	},
	entryPoint: () => {
		if (fg('project_summary_page_entry_point_migration')) {
			return summarySoftwareEmbedPageEntrypoint;
		}
	},
}));
